import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authApi, PublicUser } from '@/lib/auth';
import { ensureSocket, disconnectSocket } from '@/lib/socket';

export function useCurrentUser() {
  const q = useQuery<PublicUser | null>({
    queryKey: ['auth', 'me'],
    queryFn: () => authApi.me(),
    staleTime: 5 * 60_000,
    retry: false,
  });

  // Connect / disconnect the realtime socket as the auth state flips.
  // One socket per browser tab — see lib/socket.ts.
  useEffect(() => {
    if (q.data) {
      ensureSocket();
    } else if (q.data === null) {
      disconnectSocket();
    }
  }, [q.data]);

  return q;
}

export function useLogout() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return async () => {
    await authApi.logout();
    disconnectSocket();
    qc.setQueryData(['auth', 'me'], null);
    navigate('/');
  };
}
